import React from 'react';
import './ScrollStack.css';

/**
 * ScrollStack Component
 * Wraps children components and applies a "sticky stack" effect.
 * Each child slides over the previous one on BOTH mobile and desktop.
 */
const ScrollStack = ({ children }) => {
  // Convert children to array to map safely
  const items = React.Children.toArray(children);

  return (
    <div className="scroll-stack-wrapper1">
      {items.map((child, index) => (
        <div 
          key={index} 
          className="scroll-stack-item"
          style={{ 
            // Ensure each subsequent item sits On Top of the previous one
            zIndex: index + 1,
          }}
        >
          {child}
        </div>
      ))}
    </div>
  );
};

export default ScrollStack;